/* eslint-disable no-param-reassign */

const state = {
  draft: null,
};

const getters = {
  getDraft(st) {
    return st.draft;
  },
};

const mutations = {
  setDraft(st, payload) {
    st.draft = payload;
  },
  clearDraft(st) {
    st.draft = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/drafts.js